import { FC, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';

import { dispatch } from 'store';

import { RootState } from 'types';
import {
  setClinicRegisterData,
  signupSubClinic,
  setAccessTokenForSubClinic,
  setOpenNewWindows,
} from 'modules/auth/actions';

import { Input, Button } from 'views/components';
import { AuthLeftBlock } from '../components/AuthLeftBlock';

import { useQuery, t } from 'utils';

import styles from './Subclinics.module.css';
import { MEETINGS_HUBSPOT } from 'config';

import texts from './texts';
import { CountriesListProps } from 'modules/user/types';

export const Subclinics: FC = () => {
  const { windowWidth } = useSelector((state: RootState) => state.app);
  const { countriesList } = useSelector((state: RootState) => state.user);
  const { clinicRegisterData, errors, loading, openNewWindows } = useSelector(
    (state: RootState) => state.auth,
  );

  const tokenUrl = useQuery().get('token') || '';

  useEffect(() => {
    if(tokenUrl) {
      dispatch(setClinicRegisterData('enterpriseToken', tokenUrl));
    }
  }, [tokenUrl])
  

  const firstNameInput = clinicRegisterData.fullName.split(' ')[0] || '';
  const lastNameInput = clinicRegisterData.fullName.split(' ')[1] || '';

  const token = useQuery().get('token') || '';

  const handleInputChange = (event: any) => {
    const {
      name,
      value,
      validity: { valid },
    } = event.target;
    if (valid) {
      dispatch(setClinicRegisterData(name, value));
    }
  };

  const handleSelectChange = (event: CountriesListProps) => {
    const {value, name} = event; 
    dispatch(setClinicRegisterData(name, value || ''));
  };

  if (token) {
    dispatch(setAccessTokenForSubClinic(token));
  }

  const countryCodesList = useCallback(() => {
    if(countriesList && countriesList.length) {
      const  arr = [...countriesList];
      const newArr = arr.sort(function(a, b) {
        const nameA = a.id;
        const nameB = b.id;
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      return newArr.map((i: CountriesListProps) => {
        return {
          value: i.id,
          label: i.name,
          shortName: i.short_name,
          icon: i.icon,
          lang: i.language_code,
          curr_code: i.curr_code,
          name: 'country'
        }
      })
    }
    return []
  }, [countriesList]);  

  if (openNewWindows) {
    window.location.replace(
      `${MEETINGS_HUBSPOT}?firstname=${firstNameInput}&lastname=${lastNameInput}&email=${clinicRegisterData.email}`,
    );
    dispatch(setOpenNewWindows(false));
  }

  const SingleValue = (props: any) => {
    const {getValue} = props;
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <div style={{ marginLeft: 5 }}>{getValue()[0].label}</div>
      </div>
    );
  };


  const customStyles = {
    control: () => ({
      width: '100%',
      display: 'flex',
      alignItem: 'center',
      height: '50px',
      border: '1px solid #929295',
      borderRadius: '5px',
      backgroundColor: '#fff',
    }),
  }

  return (
    <div className={styles.wrap}>
      <AuthLeftBlock title={t(texts.title)} />
      <div className={styles.rightBlock}>
        <div className={styles.rightBlockWrap}>
          {errors?.enterpriseToken && (
            <p style={{ color: 'red', fontSize: '12px' }}>{errors?.enterpriseToken}</p>
          )}
          <Input
            name="fullName"
            value={clinicRegisterData.fullName}
            onChange={(e: any) => handleInputChange(e)}
            label={t(texts.inputLabel1)}
            error={errors.fullName}
            whiteLabel={windowWidth < 1140}
            pattern="[a-zA-Z\s]+"
            maxLength={128}
          />

          <Input
            name="email"
            value={clinicRegisterData.email}
            onChange={(e: any) => handleInputChange(e)}
            label={t(texts.inputLabel2)}
            error={errors.email}
            whiteLabel={windowWidth < 1140}
            maxLength={128}
          />

          <Input
            name="mobileNumber"
            value={clinicRegisterData.mobileNumber}
            onChange={(e: any) => handleInputChange(e)}
            label={t(texts.inputLabel4)}
            error={errors.mobileNumber}
            whiteLabel={windowWidth < 1140}
            pattern="[0-9]*"
            maxLength={16}
          />

          {/* <Input
            name="companyName"
            value={clinicRegisterData.companyName}
            onChange={(e: any) => handleInputChange(e)}
            label={t(texts.inputLabel5)}
            error={errors.clinicName}
            whiteLabel={windowWidth < 1140}
          /> */}

          <div className={styles.regionLabel}>Region</div>
          <Select
            name="country"
            value={countryCodesList().filter(i => i.value === clinicRegisterData.country)[0]}
            className={styles.region}
            onChange={(e: any) => handleSelectChange(e)}
            components={{ SingleValue }}
            options={countryCodesList()}
            styles={customStyles}
          />
          <Input
            name="storeLocation"
            value={clinicRegisterData.storeLocation}
            onChange={(e: any) => handleInputChange(e)}
            label={t(texts.inputLabel6)}
            error={errors.storeLocation}
            whiteLabel={windowWidth < 1140}
          />

          <Input
            name="storePhone"
            value={clinicRegisterData.storePhone}
            onChange={(e: any) => handleInputChange(e)}
            label={t(texts.inputLabel7)}
            error={errors.storeNumber}
            whiteLabel={windowWidth < 1140}
            pattern="[0-9]*"
            maxLength={16}
          />

          <Input
            name="password"
            value={clinicRegisterData.password}
            onChange={(e: any) => handleInputChange(e)}
            label={t(texts.inputLabel3)}
            error={errors.password}
            whiteLabel={windowWidth < 1140}
            type="password"
            maxLength={64}
          />

          <div style={{ width: '150px', marginTop: '30px', paddingBottom: '50px' }}>
            <Button
              title={t(texts.buttonText)}
              loading={loading}
              onClick={() => dispatch(signupSubClinic.request())}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
